export const withBarWrapper = (Component, { customStyles = {} }) => {
    function WrappedComponent(props) {
        return (
            <div
                style={{
                    whiteSpace: 'nowrap',
                    maxWidth: '100%',
                    fontSize: '15px',
                    fontFamily: 'sans-serif',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    ...customStyles,
                }}
            >
                <Component {...props} />
            </div>
        );
    }

    return WrappedComponent;
};
